// extracted by mini-css-extract-plugin
export default {"graphsTitle":"GraphsPage_graphsTitle__ZtOqf","graphsContainer":"GraphsPage_graphsContainer__vUGTK"};